import type { EntityEvent } from '@racemap/sdk/schema/entityEvents';
import type { RacemapEventCommon } from '@racemap/utilities/types/events';
import type { User_Legacy } from '@racemap/utilities/types/users';
import type { Immutable } from 'immer';
import { isFrontendGeneratedAlert } from './isFrontendGeneratedAlert';

export const isUserAllowedToUpdateAlert = (
  alert: EntityEvent,
  user: Immutable<User_Legacy> | null,
  event: RacemapEventCommon,
): boolean => {
  if (isFrontendGeneratedAlert(alert)) return false;
  if (!user) return false;
  if (user.admin) return true;
  if (alert.creatorId?.toHexString() === user.id) return true;

  const creatorId = event.creatorId?.toString();
  if (creatorId === user.id) return true;

  const editorIdsSet = new Set(event.editorIds ?? []);
  return editorIdsSet.has(user.id);
};
